"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBrandBodyToJSON = exports.UpdateBrandBodyFromJSONTyped = exports.UpdateBrandBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function UpdateBrandBodyFromJSON(json) {
    return UpdateBrandBodyFromJSONTyped(json, false);
}
exports.UpdateBrandBodyFromJSON = UpdateBrandBodyFromJSON;
function UpdateBrandBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'businessIcon': !(0, runtime_1.exists)(json, 'businessIcon') ? undefined : json['businessIcon'],
        'businessHeader': !(0, runtime_1.exists)(json, 'businessHeader') ? undefined : json['businessHeader'],
        'image': !(0, runtime_1.exists)(json, 'image') ? undefined : json['image'],
        'isEnabled': !(0, runtime_1.exists)(json, 'isEnabled') ? undefined : json['isEnabled'],
    };
}
exports.UpdateBrandBodyFromJSONTyped = UpdateBrandBodyFromJSONTyped;
function UpdateBrandBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
        'businessIcon': value.businessIcon,
        'businessHeader': value.businessHeader,
        'image': value.image,
        'isEnabled': value.isEnabled,
    };
}
exports.UpdateBrandBodyToJSON = UpdateBrandBodyToJSON;
